export const formatStringToPascal = (val: string) => {
	if (val?.split('_')?.length > 0) {
		return val
			.split('_')
			.reduce(
				(acc, curr) =>
					acc + curr.charAt(0).toUpperCase() + curr.slice(1),
				'',
			);
	}
	return val;
};

export const getInitials = (val: string) => {
	const value = val.trim().split(' ');
	if (!value?.length) {
		return '';
	}
	if (value.length > 1) {
		const firstName = value?.[0].substring(0, 1).toUpperCase();
		const lastName = value?.[1].substring(0, 1).toUpperCase();
		return firstName + lastName;
	}
	if (value.length > 0) {
		const firstName = value?.[0].substring(0, 1).toUpperCase();
		return firstName;
	}
};

export const getStringFromPascal = (val: string) => {
	if (!val) {
		return val;
	}
	return val.replace(/[A-Z]/g, (match, offset) => {
		return offset <= 0 ? match.toLowerCase() : '_' + match.toLowerCase();
	});
};

export const getCurrencyFormat = (
	val: number | string,
	locale = 'en-US',
	currency = 'USD',
) => {
	return Intl.NumberFormat(locale, {
		style: 'currency',
		currency: currency,
		maximumFractionDigits: 0,
	}).format(Number(val));
	// .concat(' Million');
};

export const removeCurrencyFormat = (val: string) => {
	if (val === null || val === undefined) return;
	const clean = val?.replace(/[^0-9.]/g, '');
	return clean;
};
